
/* eslint-env browser */

import merge from 'lodash/merge';

import { getSyncState, parsePulseCookies, serializePulseCookie } from './pulse-cookie';

var PIXEL_URL = 'https://secure.adnxs.com/getuid?https://cis.schibsted.com/api/v1/sync?ANID=$UID';
var APP_NEXUS_SYNC_URL = 'https://secure.adnxs.com/getuidj';
var PIXEL_ID = 'pulse2an_36jayge7acx2ge456aau2ls4tpa0z';

function insertAppNexusPixel() {
  var preExitingPixel = document.getElementById(PIXEL_ID);
  if (!preExitingPixel) {
    var img = document.createElement('img');
    img.src = PIXEL_URL;
    img.id = 'pulse2an';
    img.style.display = 'none';
    document.getElementsByTagName('body').item(0).appendChild(img);
    return true;
  }
  return false;
}

var currentRequest = Promise.resolve(false);

function serialAppNexusSync() {
  currentRequest = currentRequest.then(function () {
    return fetch(APP_NEXUS_SYNC_URL, {
      method: 'GET',
      credentials: 'include'
    }).then(function (response) {
      return response.json();
    }).then(function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          uid = _ref.uid;

      if (uid) {
        var pulse2cookie = merge({}, parsePulseCookies(), {
          anId: uid
        });
        serializePulseCookie(pulse2cookie);
        return true;
      }
      return false;
    });
  });
  return currentRequest;
}

/**
 * The boolean value of the returned Promise indicates of the sync with AppNexus
 * requires an extra sync with cis.
 */
export default function appNexusSync() {
  var _getSyncState = getSyncState(),
      syncWithAppNexus = _getSyncState.syncWithAppNexus;

  if (syncWithAppNexus) {
    var pixelInserted = insertAppNexusPixel();
    if (pixelInserted) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          return resolve();
        }, 2000);
      }).then(function () {
        return serialAppNexusSync();
      });
    }
    return Promise.resolve(false);
  }
  return Promise.resolve(false);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-cis-sync/dist/ejs/appNexus.js
// module id = 1183
// module chunks = 0